<template>
  <div class="select-city">
    <el-tooltip class="item" effect="dark" :content="cityName" placement="bottom">
      <el-button type="text" size="small" @click="openAreaPanel">
        <i class="el-icon-location"></i>
        <!-- 选择的城市名 -->
        <span class="city-names">{{ cityName }}</span>
      </el-button>
    </el-tooltip>
    <div v-show="visiable" class="cityPanel">
      <el-card>
        <!-- <div slot="header" class="clearfix">
          <el-checkbox label="多选地区" @click="ChangeMultiSelect" name="type"></el-checkbox>
          <div>（<span>VIP</span>用户可多选5个区域，<span>校本题库</span>可多选8个地区，请平行选择省份或地区）</div>
        </div> -->
        <el-row class="city-list">
          <el-col :span="4">省份：</el-col>
          <el-col :span="20">
            <el-button size="mini" :type="selection.province.ID === item.ID ? 'primary' : 'text'"
              v-for="item in provinceList" :key="item.ID" @click="changeProvince(item)" plain>
              {{ item.Name }}
            </el-button>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row class="city-list">
          <el-col :span="4">选择市/区：</el-col>
          <el-col :span="20">
            <template v-if="cityList && cityList.length">
              <el-button size="mini" :type="selection.city.ID === item.ID ? 'primary' : 'text'" v-for="item in cityList"
                :key="item.ID" @click="changeCity(item)" plain>
                {{ item.Name }}
              </el-button>
            </template>
            <template v-else>
              <div style="color: #999;">请选择省份</div>
            </template>
          </el-col>
        </el-row>
        <el-row class="flex justify-end margin-top">
          <el-button style="height: initial;" size="small" type="primary" @click="clearCity"> <i
              class="el-icon-delete"></i> 清空
          </el-button>
        </el-row>
      </el-card>
    </div>
  </div>
</template>
<script>
import store from '@/store/store.js'
export default {
  props: {
    // updateCityCode: {
    //   type: String,

    //   default() {
    //     return this.selection.city.CityCode;
    //   },
    // }, //日期区间
  },
  data() {
    return {
      multiSelect: false, //是否多选地区
      selection: {
        city: {
          CityCode: "0", ID: -1, Name: "地区"
        },
        province: {
          CityCode: "0",
          ID: -1,
          Name: "地区",
        },
      },
      cityName: "[地区]", //选择的城市名称数组
      visiable: false,
      provinceList: [], //省份列表
      cityList: [], //城市列表
    };
  },
  methods: {
    ChangeMultiSelect() {
      this.multiSelect = !this.multiSelect;
    },
    openAreaPanel() {
      this.visiable = !this.visiable;
      this.getData();
    },

    //从$store中获取地区数据，如果为空则从接口获取
    getData() {
      this.provinceList = store.state.cityList;
      //// console.log("获取地区数据", this.provinceList);
      if (this.provinceList && this.provinceList.length == 0) {
        //从接口获取地区数据
        this.axios({
          method: "GET",
          url: window.hosturl + "/hdkt/GetCity",
          // params: ,
        }).then((res) => {
          if (res.data.result == 200) {
            this.provinceList = res.data.data;
            // // console.log(res.data.data);
            // console.log("获取地区数据成功", this.provinceList);
            //获取provinceList的第一项的编号，赋值给selection.province
            if (this.provinceList.length > 0) {
              this.selection.province = this.provinceList[0];
            }

            store.commit("setCityList", res.data.data);
          } else {
            // console.log("获取地区数据失败", res.data);
            this.$message.error("获取地区数据失败");
          }
        })
      } else {
        // console.log("从store获取地区数据成功", this.selection.province);
        //默认选中省份和城市
        // if (this.provinceList.length > 0 && this.selection.province.ID == 0) {
        //   let prov = this.provinceList[0];
        //   this.selection.province = prov;
        //   this.changeProvince(prov);
        // }
        // if (this.cityList.length > 0 && this.selection.city.ID == 0) {
        //   this.selection.city = this.cityList[0];
        // }
        //// console.log("获取地区数据成功", this.cityList);
      }

      // console.log(this.provinceList);
    },
    changeProvince(item) {
      // #FIXED: 选择地区后重新获取条件选项
      // // console.log("选择省份1", this.selection.province, item);
      this.selection.province = item;
      this.cityList = item.Province;
      // // console.log("选择省份2", this.selection.province, item);
      //this.getCondition(); //重新获取条件选项
    },
    changeCity(item) {
      // // console.log("选择城市", this.selection.province.ID, item);
      this.cityName = item.Name;
      this.visiable = false;
      this.selection.city = item;
      // // console.log("选择城市222", this.selection.city);
      this.$emit('update', item);

      //遍历cityNames判断是否已经存在，不存在则添加到数组中，存在则不添加
      // let isHave = this.cityNames.find((name) => {
      //   return name == item.Name;
      // });
      // if (!isHave) {
      //   this.cityNames.push(item.Name);
      //   this.selection.city = item;
      //   this.visiable = false;
      // }
    },
    clearCity() {
      // console.log('点击了清空按钮');

      this.selection = {
        city: {
          CityCode: "0", ID: -1, Name: "地区"
        },
        province: {
          CityCode: "0",
          ID: -1,
          Name: "地区",
        },
      }
      this.cityName = "[地区]"
      this.cityList = [] // 清空城市列表
      this.visiable = false

      this.$emit('update', this.selection.city);
    },
    handleClickOutside(event) {
      // 获取城市选择面板元素
      const cityPanel = this.$el.querySelector('.cityPanel');
      // 获取触发点击事件的按钮元素
      const triggerButton = this.$el.querySelector('.el-button');

      // 如果点击的不是面板内部元素且不是触发按钮，则关闭面板
      if (this.visiable &&
        !cityPanel.contains(event.target) &&
        !triggerButton.contains(event.target)) {
        this.visiable = false;
      }
    },
  },
  mounted() {
    // 添加全局点击事件监听器
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    // 移除全局点击事件监听器
    document.removeEventListener('click', this.handleClickOutside);
  },
};
</script>
<style lang="less" scoped>
.select-city {
  float: left;

  >.el-button {
    width: 100px;
    text-align: left;

    .city-names {
      display: inline-block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 90px;
      /* 根据需要调整最大宽度 */
    }
  }

  .cityPanel {
    z-index: 100000;
    position: absolute;
    top: 40px;
    width: 80%;

    .el-card {
      position: absolute;
      width: 60vw;


      .el-card__body {
        .city-list {

          .el-button {
            color: #000;
            height: 30px;
          }

          .el-button:hover {
            // color: #fff;
            color: #008afb;
          }

          .el-button--primary {
            background-color: #85c2ff;
            color: #fff;
            padding: 0px 2px;
            height: 30px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/detail/SelectCity.vue